import React, { useEffect, useState } from "react";
import Modal from "../ui/Modal";
import { toast } from "react-toastify";

const FilterAfiliacionClientesDialog = ({
  open,
  setOpen,
  activeCols,
  setActiveCols,

}) => {



  const updateShowStateById = (service) => {

    setActiveCols(prevHeaders =>
      prevHeaders.map(header =>
          header.id === service.id ? { ...header, show: !service.show } : header
      )
  );
  
  //  const existService= activeCols.fi(obj => obj.id === service.id);
  //   if(!existService){
      
  //     setActiveCols((prev)=>([{},...prev]))
  //   }else{
  //     if(activeCols.length<=1){
  //         toast.warning("Debe haber al menos un item seleccionado")
  //         return 
  //     }
  //   const newActiveServices=activeCols.filter((obj)=>obj.id!==service.id)
  //   setActiveCols(newActiveServices);

  //  }
 
  };



  return (
    <Modal title="Filtros" activeModal={open} onClose={() => setOpen(false)}>
      <div className="flex  flex-col gap-2">
        {activeCols.map((e) => {
          return (
            <label
              key={e.id}
              className="relative inline-flex items-center cursor-pointer"
            >
              <input
                type="checkbox"
                value={""}
                onChange={() => updateShowStateById(e)}
                className="sr-only peer"
                checked={e.show}
              />
              <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-orange-200  peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all  peer-checked:bg-orange-500"></div>
              <span className="ms-3 text-sm font-medium text-gray-900 ">
                {e.name}
              </span>
            </label>
          );
        })}
      </div>

      <div className="  pt-6">
        <div className=" flex  justify-center">
          <button
            type="button"
            className=" bg-orange-600 bg-opacity-10 rounded-md text-xs py-3 px-10  text-orange-600 hover:bg-opacity-20"
            onClick={()=>setOpen(false)}
          >
            Listo
          </button>
        </div>

        
      </div>
    </Modal>
  );
};

export default FilterAfiliacionClientesDialog;
